// services/everpro/everpro-shipping/pickup.ts - services/everpro/everpro-shipping.ts split (sub-module pickup)

import { withRetry } from '../../../utils/retryLogic';
import { everproFetch } from '../everpro-auth';
import type { EverproAvailablePickupTime } from '../everpro-types';


export function defaultPickupTime(): string {
  const now = new Date(Date.now() + 7 * 60 * 60 * 1000);
  const todayHour = now.getUTCHours();
  if (todayHour >= 9) {
    now.setUTCDate(now.getUTCDate() + 1);
  }
  while (now.getUTCDay() === 0) {
    now.setUTCDate(now.getUTCDate() + 1);
  }
  const yyyy = now.getUTCFullYear();
  const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(now.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}T15:00:00+07:00`;
}



export function toRFC3339WIB(dtLocal: string): string {
  if (!dtLocal) return defaultPickupTime();
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+07:00$/.test(dtLocal)) return dtLocal;
  const d = new Date(dtLocal);
  if (isNaN(d.getTime())) return defaultPickupTime();
  const wib = new Date(d.getTime() + 7 * 3600 * 1000);
  const yyyy = wib.getUTCFullYear();
  const mm = String(wib.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(wib.getUTCDate()).padStart(2, '0');
  const hh = String(wib.getUTCHours()).padStart(2, '0');
  const min = String(wib.getUTCMinutes()).padStart(2, '0');
  const ss = String(wib.getUTCSeconds()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}+07:00`;
}



export async function fetchPickupTimes(
  rateCodes: string[],
  timezone: string = 'Asia/Jakarta',
  brandId: string,
): Promise<EverproAvailablePickupTime[]> {
  if (!brandId) throw new Error('Everpro: brandId wajib');
  const params = new URLSearchParams({
    rate_codes: rateCodes.join(','),
    timezone,
  });

  const res = await withRetry(() => everproFetch(brandId, `/shipment/v1/pickup-times?${params}`), {
    maxRetries: 2,
    initialDelayMs: 1000,
    backoffMultiplier: 2,
    shouldRetry: (err) => {
      if (err instanceof TypeError) return true;
      return false;
    },
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    throw new Error(message || `Everpro pickup times: ${res.status} ${res.statusText}`);
  }

  const json = await res.json();
  return (json?.data?.available_pickup_time ?? []) as EverproAvailablePickupTime[];
}
